"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFairRoute = exports.useBbo = exports.usePriceImpact = exports.useMarketName = exports.useMarketSlabs = exports.useMarket = exports.useOpenOrderAccounts = exports.useDexContext = exports.DexContextProvider = exports._DexContext = exports.FEE_MULTIPLIER = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var web3_js_1 = require("@solana/web3.js");
var serum_1 = require("@project-serum/serum");
var pubkeys_1 = require("../utils/pubkeys");
var TokenList_1 = require("./TokenList");
var Sollet_1 = require("./Sollet");
var Swap_1 = require("./Swap");
var usehooks_ts_1 = require("usehooks-ts");
var BASE_TAKER_FEE_BPS = 0.0022;
exports.FEE_MULTIPLIER = 1 - BASE_TAKER_FEE_BPS;
exports._DexContext = react_1.default.createContext(null);
function DexContextProvider(props) {
    var _this = this;
    var _a = (0, TokenList_1.useTokenListContext)(), wormholeMap = _a.wormholeMap, solletMap = _a.solletMap;
    var _b = (0, react_1.useState)(), route = _b[0], setRoute = _b[1];
    var _c = (0, usehooks_ts_1.useMap)(new Map()), openOrders = _c[0], openOrdersActions = _c[1];
    var _d = (0, usehooks_ts_1.useMap)(new Map()), markets = _d[0], marketsActions = _d[1];
    var _e = (0, usehooks_ts_1.useMap)(new Map()), slabMap = _e[0], slabMapActions = _e[1];
    var swapClient = props.swapClient;
    var provider = swapClient.program.provider;
    // Fetch market data route changes
    (0, react_1.useEffect)(function () {
        function setMarketsForRoute() {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, market, marketKey, savedMarket, fetchedMarket, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!route) {
                                return [2 /*return*/];
                            }
                            _i = 0, _a = route === null || route === void 0 ? void 0 : route.markets;
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 6];
                            market = _a[_i];
                            marketKey = market.toString();
                            savedMarket = markets.get(marketKey);
                            if (!!savedMarket) return [3 /*break*/, 5];
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, serum_1.Market.load(provider.connection, market, provider.opts, pubkeys_1.DEX_PID)];
                        case 3:
                            fetchedMarket = _b.sent();
                            marketsActions.set(marketKey, fetchedMarket);
                            return [3 /*break*/, 5];
                        case 4:
                            error_1 = _b.sent();
                            console.log("Failed to fetch market", error_1);
                            return [3 /*break*/, 5];
                        case 5:
                            _i++;
                            return [3 /*break*/, 1];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        }
        setMarketsForRoute();
    }, [route]);
    // Update OpenOrders when route or wallet changes
    var walletKey = provider.wallet.publicKey;
    (0, react_1.useEffect)(function () {
        function setOpenOrdersForRoute() {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, market, marketKey, savedOo, savedMarket, fetchedOpenOrders, error_2;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!route) {
                                return [2 /*return*/];
                            }
                            if (!walletKey) {
                                if ((openOrders === null || openOrders === void 0 ? void 0 : openOrders.size) !== 0) {
                                    openOrdersActions.reset();
                                }
                                return [2 /*return*/];
                            }
                            _i = 0, _a = route === null || route === void 0 ? void 0 : route.markets;
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 6];
                            market = _a[_i];
                            marketKey = market.toString();
                            savedOo = openOrders.get(marketKey);
                            if (!!savedOo) return [3 /*break*/, 5];
                            savedMarket = markets.get(marketKey);
                            // exit if market client is not saved
                            if (!savedMarket) {
                                return [2 /*return*/];
                            }
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, savedMarket.findOpenOrdersAccountsForOwner(provider.connection, walletKey)];
                        case 3:
                            fetchedOpenOrders = _b.sent();
                            openOrdersActions.set(marketKey, fetchedOpenOrders);
                            return [3 /*break*/, 5];
                        case 4:
                            error_2 = _b.sent();
                            console.error("Failed to get open order accounts", error_2);
                            return [3 /*break*/, 5];
                        case 5:
                            _i++;
                            return [3 /*break*/, 1];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        }
        setOpenOrdersForRoute();
    }, [route, markets, walletKey]);
    var addOpenOrderAccount = function (market, accountData) {
        openOrdersActions.set(market.toString(), [accountData]);
    };
    // Types of routes.
    //
    // 1. Direct trades on USDC quoted markets.
    // 2. Transitive trades across two USDC qutoed markets.
    // 3. Wormhole <-> Sollet one-to-one swap markets.
    // 4. Wormhole <-> Native one-to-one swap markets.
    //
    var updateRoute = function (fromMint, toMint) { return __awaiter(_this, void 0, void 0, function () {
        var swapMarket, wormholeMarket, kind, markets_1, kind;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, wormholeSwapMarket(provider.connection, fromMint, toMint, wormholeMap, solletMap)];
                case 1:
                    swapMarket = _a.sent();
                    if (swapMarket) {
                        wormholeMarket = swapMarket[0], kind = swapMarket[1];
                        setRoute({ markets: [wormholeMarket], kind: kind });
                    }
                    else {
                        markets_1 = swapClient.route(fromMint.equals(pubkeys_1.SOL_MINT) ? pubkeys_1.WRAPPED_SOL_MINT : fromMint, toMint.equals(pubkeys_1.SOL_MINT) ? pubkeys_1.WRAPPED_SOL_MINT : toMint);
                        // console.log("Got route markets", markets);
                        if (markets_1) {
                            kind = "usdx";
                            setRoute({ markets: markets_1, kind: kind });
                        }
                        else {
                            setRoute(undefined);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // Poll for bid and ask slabs to display current price of token
    (0, usehooks_ts_1.useInterval)(function () { return __awaiter(_this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            if (!route) {
                return [2 /*return*/];
            }
            route.markets.forEach(function (market) { return __awaiter(_this, void 0, void 0, function () {
                var marketKey, marketClient, bids, asks, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            marketKey = market.toString();
                            marketClient = markets.get(marketKey);
                            if (!marketClient) {
                                return [2 /*return*/];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, , 5]);
                            return [4 /*yield*/, marketClient.loadBids(provider.connection)];
                        case 2:
                            bids = _a.sent();
                            return [4 /*yield*/, marketClient.loadAsks(provider.connection)];
                        case 3:
                            asks = _a.sent();
                            slabMapActions.set(marketKey, { bids: bids, asks: asks });
                            return [3 /*break*/, 5];
                        case 4:
                            error_3 = _a.sent();
                            console.error("Failed to poll for slabs", error_3);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); }, route ? 10000 : null);
    return ((0, jsx_runtime_1.jsx)(exports._DexContext.Provider, __assign({ value: {
            addOpenOrderAccount: addOpenOrderAccount,
            swapClient: swapClient,
            openOrders: openOrders,
            openOrdersActions: openOrdersActions,
            markets: markets,
            marketsActions: marketsActions,
            slabMap: slabMap,
            slabMapActions: slabMapActions,
            route: route,
            updateRoute: updateRoute,
        } }, { children: props.children }), void 0));
}
exports.DexContextProvider = DexContextProvider;
function useDexContext() {
    var ctx = (0, react_1.useContext)(exports._DexContext);
    if (ctx === null) {
        throw new Error("Context not available");
    }
    return ctx;
}
exports.useDexContext = useDexContext;
/**
 * Return all OpenOrder accounts of a user for a given market
 */
function useOpenOrderAccounts(market) {
    var openOrders = useDexContext().openOrders;
    return market ? openOrders.get(market.toString()) : undefined;
}
exports.useOpenOrderAccounts = useOpenOrderAccounts;
/**
 * Get saved Market client for given market public key
 * @param market public key
 * @returns Market | undefined
 */
function useMarket(market) {
    var markets = useDexContext().markets;
    return market ? markets.get(market.toString()) : undefined;
}
exports.useMarket = useMarket;
/**
 * Get bid and ask slabs for the given market
 * Used to calculate BBO and price impact
 * @param market
 * @returns Slabs
 */
function useMarketSlabs(market) {
    var slabMap = useDexContext().slabMap;
    return market ? slabMap.get(market === null || market === void 0 ? void 0 : market.toString()) : undefined;
}
exports.useMarketSlabs = useMarketSlabs;
function useMarketName(market) {
    var _a, _b;
    var marketClient = useMarket(market);
    var baseTokenInfo = (0, TokenList_1.useTokenInfo)(marketClient === null || marketClient === void 0 ? void 0 : marketClient.baseMintAddress);
    var quoteTokenInfo = (0, TokenList_1.useTokenInfo)(marketClient === null || marketClient === void 0 ? void 0 : marketClient.quoteMintAddress);
    if (!marketClient) {
        return null;
    }
    var baseTicker = (_a = baseTokenInfo === null || baseTokenInfo === void 0 ? void 0 : baseTokenInfo.symbol) !== null && _a !== void 0 ? _a : "-";
    var quoteTicker = (_b = quoteTokenInfo === null || quoteTokenInfo === void 0 ? void 0 : quoteTokenInfo.symbol) !== null && _b !== void 0 ? _b : "-";
    return "".concat(baseTicker, " / ").concat(quoteTicker);
}
exports.useMarketName = useMarketName;
// TODO handle edge case of insufficient liquidity
function usePriceImpact(market) {
    var _a = (0, Swap_1.useSwapContext)(), toAmount = _a.toAmount, toMint = _a.toMint;
    var orderbook = useMarketSlabs(market);
    if (orderbook === undefined) {
        return undefined;
    }
    var orders = toMint.equals(orderbook.bids.market.baseMintAddress)
        ? orderbook.asks.items(false)
        : orderbook.bids.items(true);
    var remainingAmount = toAmount;
    var order = orders.next();
    var initialPrice = order.value.price;
    var priceAfterOrder = initialPrice;
    while (!order.done && remainingAmount > 0) {
        priceAfterOrder = order.value.price;
        remainingAmount =
            remainingAmount > order.value.size
                ? remainingAmount - order.value.size
                : 0;
        order = orders.next();
    }
    var priceChange = Math.abs(initialPrice - priceAfterOrder);
    var impact = (priceChange * 100) / initialPrice;
    return impact;
}
exports.usePriceImpact = usePriceImpact;
// Fair price for a given market, as defined by the mid.
function useBbo(market) {
    var orderbook = useMarketSlabs(market);
    if (orderbook === undefined) {
        return undefined;
    }
    var bestBid = orderbook.bids.items(true).next().value;
    var bestOffer = orderbook.asks.items(false).next().value;
    if (!bestBid && !bestOffer) {
        return {};
    }
    if (!bestBid) {
        return { bestOffer: bestOffer.price };
    }
    if (!bestOffer) {
        return { bestBid: bestBid.price };
    }
    var mid = (bestBid.price + bestOffer.price) / 2.0;
    return { bestBid: bestBid.price, bestOffer: bestOffer.price, mid: mid };
}
exports.useBbo = useBbo;
// Fair price for a theoretical toMint/fromMint market. I.e., the number
// of `fromMint` tokens to purchase a single `toMint` token. Aggregates
// across a trade route, if needed.
function useFairRoute(fromMint, toMint) {
    var route = useDexContext().route;
    var fromBbo = useBbo(route === null || route === void 0 ? void 0 : route.markets[0]);
    var fromMarket = useMarket(route === null || route === void 0 ? void 0 : route.markets[0]);
    var toBbo = useBbo(route === null || route === void 0 ? void 0 : route.markets[1]);
    var isWrapUnwrap = (0, Swap_1.useIsWrapSol)(fromMint, toMint).isWrapUnwrap;
    if (isWrapUnwrap) {
        return undefined;
    }
    if (!route) {
        return undefined;
    }
    if (route.markets.length === 1 && fromBbo !== undefined) {
        if (fromMarket === undefined) {
            return undefined;
        }
        if ((fromMarket === null || fromMarket === void 0 ? void 0 : fromMarket.baseMintAddress.equals(fromMint)) ||
            ((fromMarket === null || fromMarket === void 0 ? void 0 : fromMarket.baseMintAddress.equals(pubkeys_1.WRAPPED_SOL_MINT)) &&
                fromMint.equals(pubkeys_1.SOL_MINT))) {
            return fromBbo.bestBid && 1.0 / fromBbo.bestBid;
        }
        else {
            return fromBbo.bestOffer && fromBbo.bestOffer;
        }
    }
    if (fromBbo === undefined ||
        fromBbo.bestBid === undefined ||
        toBbo === undefined ||
        toBbo.bestOffer === undefined) {
        return undefined;
    }
    return toBbo.bestOffer / fromBbo.bestBid;
}
exports.useFairRoute = useFairRoute;
// Maps fromMint || toMint (in sort order) to swap market public key.
// All markets for wormhole<->native tokens should be here, e.g.
// USDC <-> wUSDC.
var WORMHOLE_NATIVE_MAP = new Map([
    [wormKey(pubkeys_1.WORM_USDC_MINT, pubkeys_1.USDC_MINT), pubkeys_1.WORM_USDC_MARKET],
    [wormKey(pubkeys_1.WORM_USDT_MINT, pubkeys_1.USDT_MINT), pubkeys_1.WORM_USDT_MARKET],
]);
function wormKey(fromMint, toMint) {
    var _a = fromMint < toMint ? [fromMint, toMint] : [toMint, fromMint], first = _a[0], second = _a[1];
    return first.toString() + second.toString();
}
function wormholeSwapMarket(conn, fromMint, toMint, wormholeMap, solletMap) {
    return __awaiter(this, void 0, void 0, function () {
        var market;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    market = wormholeNativeMarket(fromMint, toMint);
                    if (market !== null) {
                        return [2 /*return*/, [market, "wormhole-native"]];
                    }
                    return [4 /*yield*/, wormholeSolletMarket(conn, fromMint, toMint, wormholeMap, solletMap)];
                case 1:
                    market = _a.sent();
                    if (market === null) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, [market, "wormhole-sollet"]];
            }
        });
    });
}
function wormholeNativeMarket(fromMint, toMint) {
    var _a;
    return (_a = WORMHOLE_NATIVE_MAP.get(wormKey(fromMint, toMint))) !== null && _a !== void 0 ? _a : null;
}
// Returns the market address of the 1-1 sollet<->wormhole swap market if it
// exists. Otherwise, returns null.
function wormholeSolletMarket(conn, fromMint, toMint, wormholeMap, solletMap) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var fromWormhole, isFromWormhole, toWormhole, isToWormhole, fromSollet, isFromSollet, toSollet, isToSollet, base, _b, quote, wormholeInfo, solletInfo, market, marketExists;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    fromWormhole = wormholeMap.get(fromMint.toString());
                    isFromWormhole = fromWormhole !== undefined;
                    toWormhole = wormholeMap.get(toMint.toString());
                    isToWormhole = toWormhole !== undefined;
                    fromSollet = solletMap.get(fromMint.toString());
                    isFromSollet = fromSollet !== undefined;
                    toSollet = solletMap.get(toMint.toString());
                    isToSollet = toSollet !== undefined;
                    if (!((isFromWormhole || isToWormhole) && isFromWormhole !== isToWormhole)) return [3 /*break*/, 4];
                    if (!((isFromSollet || isToSollet) && isFromSollet !== isToSollet)) return [3 /*break*/, 4];
                    base = isFromSollet ? fromMint : toMint;
                    _b = isFromWormhole
                        ? [fromMint, fromWormhole]
                        : [toMint, toWormhole], quote = _b[0], wormholeInfo = _b[1];
                    return [4 /*yield*/, (0, Sollet_1.fetchSolletInfo)(base)];
                case 1:
                    solletInfo = _c.sent();
                    if (solletInfo.erc20Contract !== ((_a = wormholeInfo.extensions) === null || _a === void 0 ? void 0 : _a.address)) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, deriveWormholeMarket(base, quote)];
                case 2:
                    market = _c.sent();
                    if (market === null) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, (0, Sollet_1.requestWormholeSwapMarketIfNeeded)(conn, base, quote, market, solletInfo)];
                case 3:
                    marketExists = _c.sent();
                    if (!marketExists) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, market];
                case 4: return [2 /*return*/, null];
            }
        });
    });
}
// Calculates the deterministic address for the sollet<->wormhole 1-1 swap
// market.
function deriveWormholeMarket(baseMint, quoteMint, version) {
    if (version === void 0) { version = 0; }
    return __awaiter(this, void 0, void 0, function () {
        var padToTwo, seed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (version > 99) {
                        console.log("Swap market version cannot be greater than 99");
                        return [2 /*return*/, null];
                    }
                    if (version < 0) {
                        console.log("Version cannot be less than zero");
                        return [2 /*return*/, null];
                    }
                    padToTwo = function (n) { return (n <= 99 ? "0".concat(n).slice(-2) : n); };
                    seed = baseMint.toString().slice(0, 15) +
                        quoteMint.toString().slice(0, 15) +
                        padToTwo(version);
                    return [4 /*yield*/, web3_js_1.PublicKey.createWithSeed(pubkeys_1.WORM_MARKET_BASE, seed, pubkeys_1.DEX_PID)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
